/**
 * Per-annotation Fabric event listeners: hover tooltips, selection/deselection
 * bridging to Vue, and right-click (label edit) handling. Mixed into
 * BboxCanvas.prototype.
 *
 * Scaling/moving themselves are handled by Fabric natively plus the canvas-level
 * `object:scaling` / `object:modified` handlers in the constructor.
 */
export default {
    addEventListerenersForAnnotation(annotation) {

        let this2 = this;
        annotation.on('mousedown', function () {
            if (this2.placementMode) {
                return;
            }
            window.dispatchEvent(new CustomEvent(this2.canvasId + "canvas_selected", {
                detail: {
                    id: this2.canvasId,
                    annotation_id: annotation.annotation_id
                }
            }));
        });

        annotation.on({
            'modified': function () {

            }
        });

        annotation.on('mouseover', function (e) {
            // Get mouse position in canvas coordinate space (accounts for zoom/pan)
            let pointer = this2.canvas.getPointer(e.e);
            let mouseX = pointer.x;
            let mouseY = pointer.y;

            // Get annotation label
            let label = annotation.annotation ? annotation.annotation.label : annotation.category || 'Unknown';
            let conf = annotation.annotation ? annotation.annotation.conf : 1;

            // Add confidence to label if not 1
            let displayText = label;
            if (conf != 1) {
                displayText = label + ' ' + conf;
            }

            // Get annotation color
            let color = 'rgba(0, 0, 0, 0.8)'; // Default fallback
            if (annotation.annotation && annotation.annotation.color_values) {
                let colorValues = annotation.annotation.color_values;
                color = `rgba(${colorValues[0]}, ${colorValues[1]}, ${colorValues[2]}, 0.8)`;
            } else if (annotation.stroke) {
                // Use the stroke color if available
                color = annotation.stroke;
            }

            // Create tooltip at mouse position with annotation color
            this2.createTooltip(displayText, mouseX, mouseY, color);
        });

        annotation.on('mouseout', function () {
            // Remove tooltip when mouse leaves annotation
            this2.removeTooltip();
        });

        annotation.on('mousemove', function (e) {
            // Update tooltip position as mouse moves
            if (this2.tooltip && this2.tooltipText) {
                let pointer = this2.canvas.getPointer(e.e);
                this2.positionTooltip(pointer.x, pointer.y);
            }
        });


        annotation.on('mousedown', function (e) {
            if (this2.placementMode) {
                return;
            }
            // Middle mouse: pan the viewport without moving this annotation.
            if (e.button === 2 && this2._beginMiddlePan(e)) {
                return false;
            }
            if(e.button === 3 || this2.alt_pressed) {
                // Right click on annotation - show popup for label change
                e.e.preventDefault();
                e.e.stopPropagation();

                let rect = this2.canvas.getElement().getBoundingClientRect();
                let mouseX = e.e.clientX - rect.left;
                let mouseY = e.e.clientY - rect.top;

                window.dispatchEvent(new CustomEvent(this2.canvasId + "annotation_right_click", {
                    detail: {
                        annotation: annotation.annotation,
                        x: mouseX,
                        y: mouseY
                    }
                }));
                return false;
            }
            else {

                if (!e.target.annotation.selected) {
                    e.target.annotation.selected = true
                    window.dispatchEvent(new CustomEvent("select_annotation", {
                        detail: {
                            id: e.target.annotation_id,
                        }
                    }));
                    this2.deselectOnMouseUp = false;
                } else {
                    let obj = this;
                    let left = obj.left;
                    let top = obj.top;

                    this2.deselectOnMouseUp = true;
                    this2.deselectOnMouseUpPositionTop = top;
                    this2.deselectOnMouseUpPositionLeft = left;
                }
             }
        });

        // Add contextmenu event listener to prevent browser context menu
        annotation.on('contextmenu', function (e) {
            e.e.preventDefault();
            e.e.stopPropagation();
            return false;
        });

        annotation.on('mouseup', function (opt) {
            if (this2.placementMode) {
                return;
            }

            if(opt.button === 3) {
                this2.canvas.isDragging = false;
            }
            else {
                // on mouse up we want to recalculate new interaction
                // for all objects, so we call setViewportTransform
                this2.canvas.setViewportTransform(this2.canvas.viewportTransform);
                this2.canvas.isDragging = false;
                this2.canvas.selection = true;
            }

            if(!this2.shift_pressed && this2.deselectOnMouseUp) {
                this2.deselectOnMouseUp = false;
                let obj = this;
                let left = obj.left;
                let top = obj.top;

                if(parseInt(left) === parseInt(this2.deselectOnMouseUpPositionLeft) &&
                  parseInt(top) === parseInt(this2.deselectOnMouseUpPositionTop) ) {
                    opt.target.annotation.selected = false
                    window.dispatchEvent(new CustomEvent("unselect_annotation", {
                        detail: {
                            id: opt.target.annotation_id,
                        }
                    }));
                    opt.target.annotation.selected = false
                    this2.canvas.discardActiveObject();
                    this2.canvas.requestRenderAll();
                }
            }


        });


    },
};
